import { render, staticRenderFns } from "./UserBlockModal.vue?vue&type=template&id=1a580994&scoped=true&"
import script from "./UserBlockModal.vue?vue&type=script&lang=js&"
export * from "./UserBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a580994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a580994')) {
      api.createRecord('1a580994', component.options)
    } else {
      api.reload('1a580994', component.options)
    }
    module.hot.accept("./UserBlockModal.vue?vue&type=template&id=1a580994&scoped=true&", function () {
      api.rerender('1a580994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Users/UserBlockModal.vue"
export default component.exports